<template>
    <SignaloDialog
        :icon="'mdi-cog-outline'"
        :title="$t('common.shiftSchema')"
        :open="open"
        @close="() => closeDialog(false)"
    >
        <template #body>
            <SignaloPageLoading v-if="loading" />
            <div v-else>
                <v-form ref="dataForm" v-model="dataValid" lazy-validation>
                    <SignaloTranslatableTabs
                        v-slot="{ value, update }"
                        v-model="names"
                        :currentLanguage="$i18n?.locale"
                        :availableLocales="getAvailableLocales()"
                    >
                        <v-card-text>
                            <v-text-field
                                :label="$t('common.name')"
                                :modelValue="value"
                                @update:modelValue="update"
                                :rules="rules"
                                variant="outlined"
                                required
                                color="var(--greyscale-100)"
                            >
                            </v-text-field>
                        </v-card-text>
                    </SignaloTranslatableTabs>
                    <v-card-text>
                        <v-checkbox
                            color="primary"
                            v-model="main"
                            :label="$t('common.mainShift')"
                        ></v-checkbox>
                    </v-card-text>
                </v-form>
            </div>
        </template>
        <template #buttons>
            <v-btn class="mr-4" @click="() => closeDialog(false)">
                {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
                variant="elevated"
                :loading="dataSaving"
                color="primary"
                @click="saveData"
                :disabled="
                    !authStore.tenant.supportedLocales.every((sl) => names[sl])
                "
            >
                {{ $t('common.save') }}
            </v-btn>
        </template>
    </SignaloDialog>
</template>

<script>
import * as AUTH_STORE from 'signalo-vue-auth-store';
import * as SIGNALO_VUE_HELPERS_STORE from 'signalo-vue-helpers-store';
export default {
    props: ['open', 'mode', 'editedItem'],
    setup() {
        const authStore = AUTH_STORE.default();
        const helpersStore = SIGNALO_VUE_HELPERS_STORE.default();
        return { authStore, helpersStore };
    },
    data() {
        return {
            dataSaving: false,
            supportedLocales: [],
            dataValid: true,
            names: {},
            main: Boolean(this.editedItem?.main)
        };
    },
    created() {
        this.supportedLocales = Object.values(
            this.authStore.tenant.supportedLocales
        );
        this.supportedLocales.forEach((sl) => {
            this.names[sl] = this.editedItem?.name?.[sl] || null;
        });
    },
    computed: {
        rules() {
            return [(v) => !!v || this.$t('common.fieldRequired')];
        },
    },
    methods: {
        async saveData() {
            await this.$refs.dataForm.validate();
            if (!this.dataValid) return;
            this.dataSaving = true;
            let method;
            this.mode === 'edit' ? (method = 'PUT') : (method = 'POST');
            let url = '/shift_schemas';
            let data = { name: this.names, main: this.main };
            if (this.mode === 'edit') {
                url += '/' + this.editedItem.id;
            }
            this.axios
                .request({ url, method, data })
                .then((res) => {
                    this.helpersStore.snackbar(
                        this.$t('common.saved'),
                        'success'
                    );
                    this.closeDialog(true, res?.data?.item);
                })
                .catch((e) => {
                    if (e?.response?.status == 401) return;
                })
                .finally(() => {
                    this.dataSaving = false;
                });
        },
        closeDialog(refetchData = false, newShiftSchema = null) {
            this.$emit('closeDialog', refetchData, newShiftSchema);
        },
    },
};
</script>
